// extracted by mini-css-extract-plugin
export var orderSummary = "_k7-0";
export var showMoreLessButton = "_k7-1";